(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterPropertiesMultiSaveDialog(
    $timeout, toastr, $filter, $location, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerPropertiesMulti/printerPropertiesMultiSaveDialog/printerPropertiesMultiSaveDialog.template.html',
      link: function(scope) {
        
        let saveCounter = 0;
        scope.printers = angular.copy(scope.context.printers);
        const portProtocol = scope.context.portProtocol;
        scope.printersOriginal = angular.copy(scope.context.printers);
        scope.saveComplete = false;
        scope.dialogMessage = 'WorkingOnIt';


        (function() {
          prepPrinters();
        })();

        function prepPrinters () {
          scope.printers.forEach((printer) => {
            printer.saveStatus = {
              state: 'PENDING', 
              startTime: new Date().getTime(),
              endTime: null
            }
          });
          executeThrottledPrinterSave();
        }
        
        function executeThrottledPrinterSave () {
          $timeout(() => {
            let printer = scope.printers[saveCounter];
            let printerOriginal = scope.printersOriginal[saveCounter];
            printer.info.location = scope.context.location ? scope.context.location : printer.info.location;
            if (scope.context.selectedSNMP) {
              printer.info.snmpConfiguration = scope.context.selectedSNMP.info._links.self.href;
            }
            saveCounter += 1;

            $timeout(() => {
              if (portProtocol.testSavePortProtocol(printer)) {
                savePortProtocol(printer, printerOriginal, saveCounter);
              } else if (portProtocol.resetToDefault) {
                resetToDefaultPortProtocol(printer, printerOriginal, saveCounter);
              } else {
                savePrinter(printer, printerOriginal, saveCounter);
              }
            }, 500)

            if (saveCounter < scope.printers.length) {
              executeThrottledPrinterSave();
            }

          }, 500)
        };

        function savePortProtocol(printer, printerOriginal, saveCounterIntINPUT) {
          printerOriginal.savePortProtocol(portProtocol).then(function(response) {
            savePrinter(printer, printerOriginal, saveCounterIntINPUT);
          }).catch(function(error) {
            savePrinter(printer, printerOriginal, saveCounterIntINPUT);
          });
        }

        function resetToDefaultPortProtocol(printer, printerOriginal, saveCounterIntINPUT) {
          printerOriginal.resetToDefaultPortProtocol().then(function(response) {
            savePrinter(printer, printerOriginal, saveCounterIntINPUT);
          }).catch(function(error) {
            savePrinter(printer, printerOriginal, saveCounterIntINPUT);
          });
        }

        function savePrinter(printer, printerOriginal, saveCounterIntINPUT) {

          let saveCounterInt = saveCounterIntINPUT;

          printerOriginal.multiSave(printer, scope.context.selectedNetwork).then((response) => {
            printer.saveStatus.state = 'DONE';
            printer.saveStatus.endTime = new Date().getTime() - printer.saveStatus.startTime;
            if (saveCounterInt === scope.printers.length) {
              saveCounter = 0;
              toast()
              $rootScope.$broadcast('REFRESH_MULTI_EDIT_PRINTERS');
            }
          }).catch((error) => {
            printer.saveStatus.error = error.data.errorText;
            printer.saveStatus.state = 'FAILED';
            printer.saveStatus.endTime = new Date().getTime() - printer.saveStatus.startTime;
            if (saveCounterInt === scope.printers.length) {
              saveCounter = 0;
              toast()
              $rootScope.$broadcast('REFRESH_MULTI_EDIT_PRINTERS');
            }
          });
        };

        function toast() {
          scope.saveComplete = true;
          // scope.context.form.$setPristine();
          if (scope.printers.every((queue) => queue.saveStatus.error)) {
            scope.dialogMessage = 'Failed';
            toastr.error($filter('translate')('ERROR'))
          }

          if (scope.printers.some((queue) => queue.saveStatus.error)) {
            scope.dialogMessage = 'WARNING';
            toastr.warning($filter('translate')('WARNING'))
          }

          if (scope.printers.every((queue) => !queue.saveStatus.error)) {
            scope.dialogMessage = 'ChangesSaved';
            toastr.success($filter('translate')('ChangesSaved'))
          }
        }

        scope.closeAndExit = function () {
          scope.callback()
        }

      }
    };
  }

  pxPrinterPropertiesMultiSaveDialog.$inject = [
    '$timeout', 'toastr', '$filter', '$location', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrinterPropertiesMultiSaveDialog', pxPrinterPropertiesMultiSaveDialog);

})();
